detailedResultCount = 1;
$(document).ready(function () {
    $("#content").delegate("button.updateResults", "click", function () {
        var checkedCheckBoxes = $('input[type="checkbox"][name="' + $(this).attr('data-checkboxname') + '"]:checked');
        if ($(this).attr('data-checkboxname').length > 0 && checkedCheckBoxes.length == 0) {
            createDialog('alert', gettext('Please select at least one item above'), gettext('Selection Error'));
            return false;
        } else {
            $(".applyToSelected").not($(this).parents(".applyToSelected")).find(":input:not(:disabled)").prop("disabled", true).addClass("formSubmitDisabled");
            ajaxSubmit($(this), "updateResults=1", 'updateResults');
            return false;
        }
    }).delegate(".applyToSelected a:not(.ignoreApplyToSend)", "mousedown", function (e) {
        var href = $(this).closest('.optionsPanel').find("input:checkbox[href]").attr('href');
        if (href.charAt(0) != ".") {
            href = "input[name='" + href + "']:not(:disabled)";
        }
        var checkedCheckBoxes = $(href + ':checked');
        if (!$(checkedCheckBoxes).exists()) {
            createDialog('alert', gettext('Please select at least one item above'), gettext('Selection Error'));
            return false;
        }
    }).delegate(".commissionSettings", "change", function () {
        var FIXED_PERCENTAGE = 1;
        var FIXED_AMOUNT = 2;
        var $this = $(this); // cache the object since it is used multiple times
        var thisValue = parseInt($this.val()); // then cache the value as it is also used multiple times
        var percentage = thisValue !== FIXED_PERCENTAGE; // use shorthand, and don't need the ? true:false part since it evaluates to boolean by default
        var amount = thisValue !== FIXED_AMOUNT; // same logic as what you had with your if/else statement
        var selector = 'input[name="itemCommission[' + $this.data('tierid') + ']';
        var $commissionPercentage = $(selector + '[commission_percentage]"]');
        var $commissionAmount = $(selector + '[commission_amount]"]');
        var defaultValue = $commissionPercentage.data('defaultvalue');
        var percentageOverride = $commissionPercentage.data('overridevalue');
        var amountOverride = $commissionAmount.data('overridevalue');
        $commissionPercentage.prop('disabled', percentage).toggleClass('readonly', percentage);
        $commissionAmount.prop('disabled', amount).val('').toggleClass('readonly', amount);
        if (percentage) { // if fixed amount is selected
            $commissionPercentage.val(''); // percentage column will show 0
            if (amount) { // if default is selected
                $commissionPercentage.val(defaultValue); // show default value
            } else if (amountOverride !== "") { // if fixed amount and has override amount
                $commissionAmount.val(amountOverride); // revert value back to override amount
            }
        } else if (percentageOverride !== "") { // if fixed percentage is selected and has override percentage
            $commissionPercentage.val(percentageOverride); // revert value back to override percentage amount
        } else if (defaultValue !== "") { // if fixed percentage is selected and doesnt have override percentage and has default set
            $commissionPercentage.val(defaultValue); // show default value
        }
    }).delegate(".deleteInvoice-js", "click", function () {
        if ($(this).data('loaded') === 0) {
            $.ajax({
                type: "POST",
                data: {'invoiceID': $(this).attr('id')},
                dataType: "json",
                url: "/common/ajax/accounting/hasHistoricDeferralsOnly.php",
                async: false
            }).then(data => {
                $(this).data('loaded', 1);
                if (data.hasHistoricDeferralsOnly) {
                    let current = $(this).attr('value');
                    let update = sprintf(
                        '<br /><br /><strong>%s</strong>',
                        gettext('Note: This will also delete historical deferrals of revenue.')
                    );
                    $(this).attr('value', current + update);
                }
            });
        }
    });
    var context = $(document);
    $(context).delegate(".savedSearch", "click", function () {
        var savedSearchDialog = $("#savedSearchDialog");
        $(savedSearchDialog).find("#savedSearchName").val("");
        $(savedSearchDialog).show();
        prepareDocument($("#savedSearchDialog"));
        $(context).undelegate(".saveSavedSearch", "click").delegate(".saveSavedSearch", "click", function () {
            if ($("#savedSearchName").val() != "") {
                var data = "newSavedSearch=true&name=" + $("#savedSearchName").val() + "&employeeID=" + $("#savedSearchEmployeeID").val() + "&pageURL=" + simPRODefaults.data("page-url");
                if ($("#mainTabsSelectedItem").exists()) {
                    data += "&formContent[]=mainTabsSelectedItem=" + $("#mainTabsSelectedItem").val();
                }
                if ($("#tabsSelectedItem").exists()) {
                    data += "&formContent[]=tabsSelectedItem=" + $("#tabsSelectedItem").val();
                }
                var divForm = $(".divForm:visible");
                $.each(divForm.find("*").serializeArray(), function (index, item) {
                    data += "&formContent[]=" + item.name + "=" + item.value;
                });
                var order = divForm.find(".ajaxOrder.current");
                if (order.exists()) {
                    data += "&formContent[]=order=" + order.attr("order");
                    if (order.find(".desc").exists()) {
                        data += "&formContent[]=orderDirection=DESC";
                    } else {
                        data += "&formContent[]=orderDirection=ASC";
                    }
                }
                $.ajax({
                    type: "POST",
                    url: "/common/ajax/searchPages.php",
                    data: data,
                    dataType: "json",
                    success: function (responseText, statusText, xhr, $form) {
                        $(context).undelegate(".saveSavedSearch", "click");
                        updateSavedSearches();
                        $(".dialogClose").click();
                    }
                });
            }
        });
    }).delegate(".modifyTableView, .cancelTableView, .saveTableView, .finishTableView", "click", function () {
        let divForm;
        if ($(this).attr('target')) {
            divForm = $($(this).attr('target'));
        } else {
            divForm = $(".divForm:visible");
        }
        if ($(this).is(".saveTableView, .finishTableView") && $(".tableViewCheckbox:checked", divForm).length == 0) {
            createDialog("alert", gettext("At least one field must remain selected."));
            return false;
        }
        if ($(this).hasClass("modifyTableView")) {
            $("#modifyTableView").val(1);
        } else if ($(this).hasClass("cancelTableView") || $(this).hasClass("finishTableView")) {
            $("#modifyTableView").val(0);
        }
        if ($(this).hasClass("saveTableView") || $(this).hasClass("finishTableView")) {
            var saveTableView = $("<input type='text' name='saveTableView' value='1' />").appendTo(divForm);
        }
        ajaxSubmit(divForm);
        if ($(this).hasClass("saveTableView") || $(this).hasClass("finishTableView")) {
            $(saveTableView).remove();
        }
    }).delegate(".tableViewCheckbox", "click", function () {
        let $table = $(this).closest("tbody");
        if ($table.find(".tableViewCheckbox:checked").length >= 15) {
            $table.find(".tableViewCheckbox:not(:checked)").prop("disabled", true);
        } else {
            $table.find(".tableViewCheckbox:not(:checked)").prop("disabled", false);
        }
    }).delegate(".search", "click", function () {
        // If search button is clicked, go to "All" tab
        $("#searchTextCallback").remove();
        $("#searchTextCallbackCategory").remove();
        if ($('.allCheckbox').prop("checked")) {
            $('.allCheckbox').trigger('click');
        }
        try {
            if (!history.state) {
                html = "";
                $(".divForm").each(function (index, item) {
                    html += $(item).parent().parent().parent().html();
                });
                history.replaceState(html, "", document.URL);
            }
        } catch (e) {
        }
        ajaxSubmit($(this).parents(".divForm:first"), $(this).attr("params"));
    }).delegate(".searchText", "keydown", function (e) {
        // If search button is clicked, go to "All" tab
        if (e.keyCode == 13) {
            $(this).parents(".divForm:first").find(".search").click();
            return false;
        }
    }).delegate(".advancedSearch", "click", function () {
        if ($("#showAdvancedSearch").val() == 1) {
            $("#showAdvancedSearch").val(0);
        } else {
            $("#showAdvancedSearch").val(1);
        }
    }).delegate(".changeStatus", "click", function () {
        $("#changeStatusDialog").show().find("#changeStatusSubmit").attr("params", "taskID=" + $(this).attr("id"));
    }).delegate(".selectDue", "click", function () {
        var allRecurring = $("input[name='recurring[]']:enabled");
        var recurringDue = $(".lightYellowRow input:checkbox:enabled");
        if (!$(this).prop("checked")) {
            if (recurringDue.length > 0) {
                // if unticked then unticck all that are ticked (regardless of due) so long as at least one due is ticked
                allRecurring.prop("checked", false);
                $(".selectAll").prop("checked", false);
            }
        } else {
            recurringDue.prop("checked", true);
            if (recurringDue.length > 0 && recurringDue.length === allRecurring.length) {
                // if ticking all recurring and that is all the recurring on screen then tick the select all checkbox
                $(".selectAll").prop("checked", true);
            }
        }
    }).delegate(".selectAll", "click", function () {
        var selectDue = $(".selectDue");
        if (selectDue.exists()) {
            var recurringDue = $(".lightYellowRow input:checkbox:enabled");
            if (recurringDue.length > 0) {
                // if on the recurring pages and at least one recurring due then tick the all due option
                selectDue.prop("checked", $(this).prop("checked"));
            }
        }
    }).delegate(".detailedResults", "click", function () {
        // Detailed results
        var row = $(this).closest("tr");
        if ($(row).next().hasClass("detailedResultsPanel")) {
            $(row).next().remove();
            row.removeClass('yellowRow');
        } else {
            showLoadingImage();
            var paramsArray = $(this).attr("params").split(",");
            var paramsCount = paramsArray.length;
            var count = 1;
            var html = "";
            $.each(paramsArray, function (index, params) {
                params += "&iframe=true&ajaxCall=true";
                detailedResultCount++;
                var id = detailedResultCount;
                params += "&detailsID=" + id;
                $.ajax({
                    type: "GET",
                    url: params,
                    success: function (responseText) {
                        $(".resultsTable", responseText).each(function (index, item) {
                            //The returned table NEEDS to have a menu in order to be displayed!
                            if ($(item).find("tbody tr.menuContainer").exists()) {
                                html += "<div class='divForm internalDivForm' id='divForm" + id + "' action='" + params + "'>";
                                // Header
                                html += $("<div />").append($(item).closest(".row").prev().find("h3").clone().addClass("marginBottom noMarginTop")).html();
                                var data = $(item).clone();
                                data.find(".ajaxClick").attr("callback", 'updateDetailResult');
                                html += $("<div />").append(data).html();
                                html += "</div>";
                            }
                        });
                        $(row).siblings(".detailedResultsPanel").each(function (index, item) {
                            $(item).prev().removeClass('yellowRow');
                            $(item).remove();
                        });
                        if (count == paramsCount) {
                            // Show content
                            if (html == "") {
                                html += "<div class='textCenter lightBold'>" + gettext("No further results found.") + "</div>";
                            }
                            // Show detailed results row
                            var detailedResult = $("<tr class='noHighlight sortableDisabled detailedResultsPanel moreOptionsrow'><td colspan='" + $(row).find("td").length + "'>" + html + "</td></tr>");
                            $(row).after(detailedResult);
                            row.addClass('yellowRow');
                            hideLoadingImage();
                        }
                        count++;
                    }
                });
            });
        }
        return false;
    }).delegate("[href='viewGroup'], [href='viewSubgroup'], [href='viewAssetType'], [href='viewSite'], [href='viewPlantType'], [href='viewDevice'], [href='viewCatalogueGroup'], [href='viewCatalogueGroup1'], [href='viewCatalogueGroup2'], [href='viewCatalogueGroup3'], [href='viewPrebuildGroup'], [href='viewPrebuildGroup1'], [href='viewPrebuildGroup2'], [href='viewPrebuildGroup3']", "click", function () {
        var divForm = $(this).parents(".divForm:first");
        var href = $(this).attr("href");
        var id = $(this).attr("id");
        var name = $(this).data("name");

        if (href == "viewGroup") {
            $(divForm).find("#category").val(id);
        } else if (href == "viewSubgroup") {
            $(divForm).find("#section").val(id);
        } else if (href == "viewAssetType") {
            $(divForm).find("#assetTypeID").val(id);
            // if type is an autoComplete
            $(divForm).find("#assetTypeCallback").val(id);
            $(divForm).find("#assetType").val(name);
        } else if (href == "viewSite") {
            $(divForm).find("#siteID").val(id);
        } else if (href == "viewPlantType") {
            $(divForm).find("#plantType").val(id);
        } else if (href == "viewCatalogueGroup" || href == "viewPrebuildGroup") {
            $(divForm).find("#group").val(id);
        } else if (href == "viewCatalogueGroup1" || href == "viewPrebuildGroup1") {
            $(divForm).find("#subgroup1").val(id);
        } else if (href == "viewCatalogueGroup2" || href == "viewPrebuildGroup2") {
            $(divForm).find("#subgroup2").val(id);
        } else if (href == "viewCatalogueGroup3" || href == "viewPrebuildGroup3") {
            $(divForm).find("#subgroup3").val(id);
        } else {
            $(divForm).find("#storageID").val(id);
        }
        $(divForm).find(".search").click();
    }).delegate(".headerBreadcrumb", "click", function () {
        var divForm = $(this).parents(".divForm:first");
        if (!divForm.exists()) {
            divForm = $(".divForm:first");
        }
		if ($(this).data("category")) {
            $(divForm).find("#category").remove();
            $(divForm).find("#section").remove();
            $(divForm).append("<input type='hidden' name='category' value='" + $(this).data("category") + "'><input type='hidden' name='section' value='" + $(this).data("section") + "'>");
        } else if ($(this).data("subgroup3") || $(this).data("subgroup2") || $(this).data("subgroup1") || $(this).data("group")) {
            $(divForm).find("#group").remove();
            $(divForm).find("#subgroup1").remove();
            $(divForm).find("#subgroup2").remove();
            $(divForm).find("#subgroup3").remove();
            var groupInput = "<input type='hidden' name='group' value='" + $(this).data("group") + "'>";
            var subgroup1Input = "<input type='hidden' name='subgroup1' value='" + ($(this).data("subgroup1") ? $(this).data("subgroup1") : '-1') + "'>";
            var subgroup2Input = "<input type='hidden' name='subgroup2' value='" + ($(this).data("subgroup2") ? $(this).data("subgroup2") : '-1') + "'>";
            var subgroup3Input = "<input type='hidden' name='subgroup3' value='" + ($(this).data("subgroup3") ? $(this).data("subgroup3") : '-1') + "'>";
            $(divForm).append(groupInput + subgroup1Input + subgroup2Input + subgroup3Input);
        } else if ($(this).data("assettypeid")) {
            $(divForm).find("#assetTypeID").remove();
            $(divForm).find("#siteID").remove();

            let assetTypeName = $(this).data("assettypename");

            $(divForm).find("#assetTypeCallback").val($(this).data("assettypeid"));
            $(divForm).find("#assetType").val(assetTypeName);

            $(divForm).append("<input type='hidden' name='assetTypeID' value='" + $(this).data("assettypeid") + "'><input type='hidden' name='siteID' value='" + $(this).data("siteid") + "'>");
        } else if ($(this).data("planttypeid")) {
            $(divForm).find("#plantType").suggestselect("setValue", $(this).data("planttypeid"));
        } else {
            $(divForm).find("#storageID").remove();
            $(divForm).append("<input type='hidden' name='storageID' value='" + $(this).data("storageid") + "'>");
        }
        $(divForm).find(".searchText").val('');
        $(divForm).find(".search").click();
    }).delegate(".viewGroup, .viewSubgroup, .viewDevice, .viewPlantType, .viewAssetType", "click", function () {
        $(this).parents("td").siblings(":last").click();
    }).delegate(".updatePurchaseStage", "click", function () {
        var divForm = $(".divForm:first:visible");
        var purchaseStage = $("#purchasingStage");
        $(divForm).append("<input type='hidden' name='setPurchaseStage' value='" + $(purchaseStage).val() + "'>");
        $(purchaseStage).suggestselect("setValue", "");
        ajaxSubmit(divForm);
    }).delegate(".cancelCommissionBtn", "click", function () {
        var IGNORE_UPDATE = 4;
        $('.commissionSettings').suggestselect("setValue", IGNORE_UPDATE).change();
    }).delegate(".updateCommission", "click", function () {
        var divForm = $(".divForm:first:visible");
        $(divForm).append("<input type='hidden' name='updateCommission' value='1'>");
        ajaxSubmit(divForm);
    }).delegate(".printBarcodes", "click", function () {
        var barcodes = $("[name='catalogue[]']:checked", context);
        if (barcodes.exists()) {
            window.open('/staff/formLoad.php', 'formPage');
            var form = $("<form action='forms/barcode/barcode.php' method='post' target='formPage'></form>");
            barcodes.each(function (index, item) {
                $("<input type='hidden' name='itemID[]' value='" + $(item).val() + "' />").appendTo(form);
                $("<input type='hidden' name='type[]' value='stock' />").appendTo(form);
            });
            $(form).appendTo("body").submit().remove();
        }
    }).delegate(".printStorageStockBarcodes", "click", function () {
        var barcodes = $("[name='stock[]']:checked", context);
        if (barcodes.exists()) {
            window.open('/staff/formLoad.php', 'formPage');
            var form = $("<form action='forms/barcode/barcode.php' method='post' target='formPage'></form>");
            barcodes.each(function (index, item) {
                var itemIDs = $(item).val().split("|"); // storageID|stockItemID
                $("<input type='hidden' name='itemID[]' value='" + itemIDs[1] + "' />").appendTo(form);
                $("<input type='hidden' name='type[]' value='stock' />").appendTo(form);
            });
            $(form).appendTo("body").submit().remove();
        }
    }).delegate(".printAssetBarcodes", "click", function () {
        var barcodes = $("[name='assets[]']:checked.exported", context); // making use of the exported variable here to determine if an asset has a barcode
        if (barcodes.exists()) {
            var form = $("<form action='forms/barcode/barcode.php' method='post' target='_blank'></form>");
            barcodes.each(function (index, item) {
                $("<input type='hidden' name='itemID[]' value='" + $(item).val() + "' />").appendTo(form);
                $("<input type='hidden' name='type[]' value='asset' />").appendTo(form);
            });
            $(form).appendTo("body").submit().remove();
        } else {
            createDialog("alert", gettext("There are no Barcodes for the selected Assets."), gettext("Warning"));
        }
    }).delegate(".printBarcodeList", "click", function () {
        window.open('/staff/formLoad.php', 'formPage');
        $.ajax({
            type: "POST",
            url: "/common/ajax/searchPages.php",
            data: "getBarcodeList=true",
            dataType: "json",
            success: function (responseText, statusText, xhr, $form) {
                var form = $("<form action='forms/barcode/barcode.php' method='post' target='formPage'></form>");
                $.each(responseText.stockIDs, function (index, item) {
                    $("<input type='hidden' name='itemID[]' value='" + item + "' />").appendTo(form);
                    $("<input type='hidden' name='type[]' value='stock' />").appendTo(form);
                });
                $(form).appendTo("body").submit().remove();
            }
        });
    }).delegate(".addBarcodeList, .clearBarcodeList", "click", function () {
        if ($(this).hasClass("addBarcodeList")) {
            var data = "addBarcodeList=true";
            if ($(this).attr("id")) {
                data += "&ids[]=" + $(this).attr("id");
            } else {
                $("[name='catalogue[]']:checked", context).each(function (index, item) {
                    data += "&ids[]=" + $(item).val();
                });
            }
        } else {
            var data = "clearBarcodeList=true";
        }
        $.ajax({
            type: "POST",
            url: "/common/ajax/searchPages.php",
            data: data,
            success: function (responseText, statusText, xhr, $form) {
                ajaxSubmit($(".divForm:visible"));
            }
        });
    }).on("click",".addItems", function () {
        let $activeElement = $(document.activeElement);
        if ($activeElement.hasClass('allowDigits')) {
            $activeElement.trigger('blur');
        }
        addResultItems();
    }).delegate(".itemField", "keydown click", function (e) {
        if (e.type == 'click' && $(this).val() == '') {
            $(this).val(1).select();
        } else {
            if (e.keyCode != 13) {
                return true;
            }
            addResultItems();
        }
    }).delegate(".invoiceJobs", "click", function () {
        let divForm = $(this).parents(".divForm");
        let jobs = divForm.find(".resultsTable input:checked");
        if (jobs.exists()) {
            let $form = $('<form method="POST" action="editInvoice.php"></form>');
            let formElements = function (value) {
                return '<input type="hidden" name="jobID[]" value="' + value + '" />';
            }
            let jobIds = '';
            jobs.each(function () {
                jobIds += formElements($(this).val());
            });
            $form.append(jobIds);
            if (typeof ($(this).data("retention")) != "undefined") {
                $form.append('<input type="hidden" name="claimRetention" value="true" />');
            }
            showLoadingImage();
            $('body').append($form);
            $form.submit();
        }
    }).delegate(".dialogConfirmExport", "click", function (e) {
        var $this = $(this),
                href = $this.attr("href"),
                target = "",
                confirmationMessage = $(this).data('confirmmessage'),
                confirmationTitle = "";

        if ($(this).hasClass("deleteInvoices-js")) {
            $.ajax({
                type: "POST",
                data: $("input[name='unpaid[]']").serialize(),
                dataType: "json",
                url: "/common/ajax/accounting/hasHistoricDeferralsOnly.php",
                async: false
            })
            .then(data => {
                if (data.hasHistoricDeferralsOnly) {
                    confirmationMessage += sprintf(
                        '<br /><br /><strong>%s</strong>',
                        gettext('Note: This will also delete historical deferrals of revenue.')
                    );
                }
            });
        }

        var table = $(this).parents(".divForm:first").find(".resultsTable");
        if (table.find("input.exported:checked").exists()) {
            confirmationMessage += $(this).data('confirmmessageexported');
        }
        var confirmationDialog = createDialog("confirm", confirmationMessage, "", href);
        confirmationDialog.delegate(".dialogContinue", "click", function () {
            // If OK button is clicked, run the original functionality
            $this.removeClass("dialogConfirmExport").addClass("ajaxClick");
            $this.click();
            $this.addClass("dialogConfirmExport").removeClass("ajaxClick");
            confirmationDialog.remove();
        });
        e.preventDefault();
        return false;
    }).delegate(".delete, .archive, .move, .copy, .merge, .transfer, .plantCheckIn, .plantCheckOut, .changeContract, .addServiceLevels, .changeServiceStartDate, .changeServiceDates,.removeServiceLevels, .changeStage, .createGroup, .createSubgroup, .editGroup, .editSubgroup, .setGroupMarkup, .setSubgroupMarkup, .setGroupSuppliers, .setSubgroupSuppliers, .setQuoteOrderNo", "click", function () {

        if ($(this).hasClass("customers")) {
            var type = "customers";
        } else if ($(this).hasClass("sites")) {
            var type = "sites";
        } else if ($(this).hasClass("suppliers")) {
            var type = "suppliers";
        } else if ($(this).hasClass("employees")) {
            var type = "employees";
        } else if ($(this).hasClass("pending")) {
            var type = "pending";
        } else if ($(this).hasClass("progress")) {
            var type = "progress";
        } else if ($(this).hasClass("complete")) {
            var type = "complete";
        } else if ($(this).hasClass("archive")) {
            var type = "archive";
        } else if ($(this).hasClass("catalogue")) {
            var type = "catalogue";
        } else if ($(this).hasClass("prebuild")) {
            var type = "prebuild";
        } else if ($(this).hasClass("kitBuilds")) {
            var type = "kit";
        } else if ($(this).hasClass("quote")) {
            var type = "quote";
        } else if ($(this).hasClass("job")) {
            var type = "job";
        } else if ($(this).hasClass("assets")) {
            var type = "assets";
        } else if ($(this).hasClass("contacts")) {
            var type = "contacts";
        } else if ($(this).hasClass("purchaseorders")) {
            var supplierID = supplierOrderMergeValidation($(this));
            if (!supplierID) {
                return false;
            }
            var type = "purchaseorders";
        }

        if ($(this).hasClass("delete")) {
            var id = $(this).attr("id");
            var params = type + "ID=" + id;
            $.ajax({
                type: "POST",
                url: "/common/ajax/searchPages.php",
                data: "checkHistory=true&" + type + "=true&id=" + id,
                dataType: "json",
                success: function (responseText, statusText, xhr, $form) {
                    if (responseText.checkHistory == true) {
                        $("#deleteButton").hide();
                    } else {
                        $("#deleteButton").show();
                    }
                    $("#archiveButton").attr("params", params + "&archive=true");
                    $("#deleteButton").attr("params", params + "&delete=true");
                    $("#deleteDialog").show();
                }
            });
        } else if ($(this).hasClass("merge")) {
            var divForm = $(this).closest(".divForm:not(.internalDivForm)");
            var params = "merge=true";
            var exclude = "";
            if ($(this).attr("id")) {
                params += "&" + type + "ID=" + $(this).attr("id");
                exclude = $(this).attr("id");
            } else {
                let target = type;
                if ($(this).data('target')) {
                    target = $(this).data('target');
                }
                $("input[name='" + target + "[]']:checked", divForm).each(function (index, item) {
                    if (exclude != "") {
                        exclude += "&";
                    }
                    exclude += $(item).val();
                });
            }
            $("#mergeIntoID", divForm).val("").addClass(type).removeClass("error").attr("filter-excludeids", exclude);
            if (type == "quote") {
                if ($(this).hasClass("clientOnStop")) {
                    $("#mergeIntoID", divForm)
                        .val("")
                        .addClass("quotes").removeClass("jobs")
                        .attr("filter-customerID", $(this)
                            .attr("customerID"));
                } else {
                    $("#mergeIntoID", divForm)
                        .val("")
                        .addClass("jobs quotes")
                        .attr("filter-customerID", $(this)
                            .attr("customerID"));
                }
                $("#mergeVariationDiv", divForm).show();
            } else if (type == "job") {
                $("#mergeIntoID", divForm).val("").addClass("jobs").attr("filter-customerID", $(this).attr("customerID"));
            } else if (type == "assets") {
                $("#mergeIntoID", divForm).val("").addClass("assets").attr("filter-assetTypeID", $(this).attr("assetTypeID")).attr("filter-assetTypeID", $(this).attr("assetTypeID"));
            } else if (type === 'purchaseorders') {
                $("#mergeIntoID", divForm).val("").addClass("orders")
                    .attr({
                        "filter-supplierID": supplierID,
                        "displayMode": 'Merge'
                    });
            }
            $("#mergeDialog", divForm).show().undelegate("#mergeButton", "click").delegate("#mergeButton", "click", function () {
                if (checkMandatory("#mergeDialog")) {
                    params += "&mergeIntoID=" + $("#mergeIntoIDCallback", divForm).val() + "&mergeIntoType=" + $("#mergeIntoIDCallbackCategory", divForm).val();
                    if (type == "quote") {
                         params += "&mergeVariation=" + ($("#mergeVariation", divForm).is(":checked") ? "1" : "0");
                    }
                    $(this).attr("params", params);
                } else {
                    return false;
                }
            }).find(".autofocus").focus();
        } else if ($(this).hasClass("move") || $(this).hasClass("copy")) {
            let $moveDialog = $("#moveDialog");
            let $moveGroupID = $('#moveGroupID');
            let $this = $(this);
            $.ajax({
                type : 'POST',
                url : '/common/ajax/move/' + $moveGroupID.data('ajax'),
                dataType: "json",
                success : function(responseText) {
                    let groups = '';
                    $.each(responseText.itemGroups, function (i, item) {
                        groups += "<option value='" + item.category_id + "'>" + item.category_name + "</option>";
                    });
                    $moveGroupID.find('option').not(':first').remove();
                    $moveGroupID.append(groups);
                    $moveGroupID.suggestselect('refresh');

                    groups = '';
                    $.each(responseText.itemSubgroups1, function (i, item) {
                        groups += "<option value='" + item.category_id + "' data-parentvalue='" + item.parent_id + "'>" + item.category_name + "</option>";
                    });
                    let $moveSubgroup1IDList = $('#moveSubgroup1IDList');
                    $moveSubgroup1IDList.find('option').remove();
                    $moveSubgroup1IDList.append(groups);

                    groups = '';
                    $.each(responseText.itemSubgroups2, function (i, item) {
                        groups += "<option value='" + item.category_id + "' data-parentvalue='" + item.parent_id + "'>" + item.category_name + "</option>";
                    });
                    let $moveSubgroup2IDList = $('#moveSubgroup2IDList');
                    $moveSubgroup2IDList.find('option').remove();
                    $moveSubgroup2IDList.append(groups);

                    groups = '';
                    $.each(responseText.itemSubgroups3, function (i, item) {
                        groups += "<option value='" + item.category_id + "' data-parentvalue='" + item.parent_id + "'>" + item.category_name + "</option>";
                    });
                    let $moveSubgroup3IDList = $('#moveSubgroup3IDList');
                    $moveSubgroup3IDList.find('option').remove();
                    $moveSubgroup3IDList.append(groups);

                    $moveDialog
                        .undelegate("#moveButton", "click")
                        .on("click", "#moveButton", function () {
                            if (checkMandatory("#moveDialog")) {
                                params += "&moveGroupID=" + $("#moveGroupID").val() + "&moveSubgroup1ID=" + $("#moveSubgroup1ID").val() + "&moveSubgroup2ID=" + $("#moveSubgroup2ID").val() + "&moveSubgroup3ID=" + $("#moveSubgroup3ID").val();
                                $(this).attr("params", params);
                            } else {
                                return false;
                            }
                        });
                    $('#page')
                        .on("change", "#moveGroupID", function () {
                            var sizeOfSubGroupOptions = $moveDialog.find("#moveSubgroup1ID > option").length;
                            if ($("#moveGroupID").val() === '-1' || sizeOfSubGroupOptions <= 1) {
                                $moveDialog.find("#moveSubgroup1ID").val('-1');
                                $moveDialog.find("#divSubgroup1ID").hide();
                            } else if (sizeOfSubGroupOptions > 1) {
                                $moveDialog.find("#moveSubgroup1ID").val('-1');
                                $moveDialog.find("#divSubgroup1ID").show();
                            }
                            $moveDialog.find("#moveSubgroup2ID").val('-1');
                            $moveDialog.find("#divSubgroup2ID").hide();
                            $moveDialog.find("#moveSubgroup3ID").val('-1');
                            $moveDialog.find("#divSubgroup3ID").hide();
                        }).on("change", "#moveSubgroup1ID", function () {
                        var sizeOfSubGroupOptions = $moveDialog.find("#moveSubgroup2ID > option").length;
                        if ($("#moveSubgroup1ID").val() === '-1' || sizeOfSubGroupOptions <= 1) {
                            $moveDialog.find("#moveSubgroup2ID").val('-1');
                            $moveDialog.find("#divSubgroup2ID").hide();
                        } else if (sizeOfSubGroupOptions > 1) {
                            $moveDialog.find("#moveSubgroup2ID").val('-1');
                            $moveDialog.find("#divSubgroup2ID").show();
                        }
                        $moveDialog.find("#moveSubgroup3ID").val('-1');
                        $moveDialog.find("#divSubgroup3ID").hide();
                    }).on("change", "#moveSubgroup2ID", function () {
                        var sizeOfSubGroupOptions = $moveDialog.find("#moveSubgroup3ID > option").length;
                        if ($("#moveSubgroup2ID").val() === '-1' || sizeOfSubGroupOptions <= 1) {
                            $moveDialog.find("#moveSubgroup3ID").val('-1');
                            $moveDialog.find("#divSubgroup3ID").hide();
                        } else if (sizeOfSubGroupOptions > 1) {
                            $moveDialog.find("#moveSubgroup3ID").val('-1');
                            $moveDialog.find("#divSubgroup3ID").show();
                        }
                    });
                    if ($this.hasClass("move")) {
                        var params = "move=true";
                        $("#moveCopy").hide();
                        $("#moveMove").show();
                        $("#moveButton").html($("#moveMove").html());
                        $("#moveGroupID").suggestselect("setValue", "-1").change().next().removeClass("mandatoryFail error");
                        $("#moveSubgroupID").suggestselect("setValue", "-1");
                    } else {
                        var params = "copy=true";
                        $("#moveCopy").show();
                        $("#moveMove").hide();
                        $("#moveButton").html($("#moveCopy").html());

                        //pre-select groups/subgroup
                        var group = (typeof $this.data('group') === 'undefined' ? "-1" : $this.data('group'));
                        $("#moveGroupID").suggestselect("setValue", group).change().next().removeClass("mandatoryFail error");
                        // sub group 1
                        var subgroup1 = $this.data('subgroup1');
                        // Prebuilds and Takeoffs have a default of -1 subgroup ID if no subgroup is assigned. Catalogues have a default of null.
                        // If subgroup is "", change it to "-1" to pre-select "None" in the dialog box. Their stock handler will then convert it to null.
                        if (subgroup1 == "") {
                            subgroup1 = "-1";
                        }
                        $("#moveSubgroup1ID").suggestselect("setValue", subgroup1).change();
                        // sub group 2
                        var subgroup2 = $this.data('subgroup2');
                        if (subgroup2 == "") {
                            subgroup2 = "-1";
                        }
                        $("#moveSubgroup2ID").suggestselect("setValue", subgroup2).change();
                        // sub group 3
                        var subgroup3 = $this.data('subgroup3');
                        if (subgroup3 == "") {
                            subgroup3 = "-1";
                        }
                        $("#moveSubgroup3ID").suggestselect("setValue", subgroup3).change();
                    }
                    if ($this.attr("id")) {
                        params += "&" + type + "ID=" + $this.attr("id");
                    }
                    $moveDialog.show();
                }
            });
        } else if ($(this).hasClass("addServiceLevels")) {
            if ($(this).attr("id")) {
                $("#applyAddServiceLevels").attr("params", "addServiceLevels=true&" + type + "ID=" + $(this).attr("id"));
            } else {
                $("#applyAddServiceLevels").attr("params", "addServiceLevels=true");
            }
            $("#serviceLevelWarning").addClass("hide");

            var dialog = $("#addServiceLevelsDialog");
            dialog.find("option.hide").removeClass("hide");
            dialog.find(".servicelevels-js").remove();
            dialog.find(".noResults-js").show();
            dialog.show();
            $("#addServiceLvlButton").off("click").on("click", function() {
                var serviceLevel = $("#addServiceLevel");
                var serviceLevelSelected = serviceLevel.find("option:selected");
                if (serviceLevelSelected.val() > 0) {
                    $("#serviceLevelWarning").removeClass("hide");
                    var serviceLevelBody = $("#serviceLevelBody");
                    var content = "";
                    content += "<tr class='servicelevels-js'>";
                    content +=    "<td>";
                    content +=      serviceLevelSelected.text();
                    content +=    "</td>";
                    content +=    "<td>";
                    content +=       "<div class='groupedInput'>";
                    content +=          "<input data-cy='Service_Levels_Date_" + serviceLevelSelected.text() + "' type='text' name='serviceLevelDate[" + serviceLevelSelected.val() + "]' class='datePicker' value='" + serviceLevelBody.data("date") + "' />";
                    content +=       "</div>";
                    content +=    "</td>";
                    content += "</tr>";
                    serviceLevelBody.find(".noResults-js").hide();
                    serviceLevelSelected.addClass("hide").prop("selected", false);
                    serviceLevel.suggestselect("refresh");
                    serviceLevelBody.append(content);
                    prepareDocument(serviceLevelBody);
                }
            });
        } else if ($(this).hasClass("transfer")) {
            let params = "transfer=true";
            let assets = '';
            if ($(this).attr("id")) {
                params += "&assetsID=" + $(this).attr("id");
                assets += "&assetID[]=" + $(this).attr("id");
            } else {
                $("[name='assets[]']:checked", context).each(function (index, item) {
                    assets += "&assetID[]=" + $(item).val();
                });
            }
            $.ajax({
                type : 'POST',
                url : '/common/ajax/checkAssetChildCount.php',
                data: assets,
                success : function(responseText) {
                    $('#transferChildAssets').prop('checked', false);
                    if (parseInt(responseText) > 0) {
                        $('#childCount').html(responseText);
                        $('#assetChildDiv').removeClass('hide');
                    } else {
                        $('#assetChildDiv').addClass('hide');
                    }
                }
            });
            $("#transferToID").val("");
            $("#transferDialog").show().undelegate("#transferButton", "click").delegate("#transferButton", "click", function () {
                if (checkMandatory("#transferDialog")) {
                    params += "&transferToID=" + $("#transferToIDCallback").val() + "&transferToName=" + $('input[name=transferToID]').val();
                    params += '&transferChildAssets=' + ($('#transferChildAssets').is(":checked") ? "true" : "false");
                    $(this).attr("params", params);
                } else {
                    return false;
                }
            });
        } else if ($(this).hasClass("changeContract")) {
            var params = "";
            if ($(this).attr("id")) {
                params += "&" + type + "[]=" + $(this).attr("id");
            }
            $.ajax({
                type: "POST",
                url: "/common/ajax/searchPages.php",
                data: "getContracts=true&siteID=" + $(this).attr("siteID"),
                dataType: "json",
                success: function (responseText, statusText, xhr, $form) {
                    let $changeContract = $("#changeContract");
                    $changeContract.html("");
                    $("<option value='-1'>" + gettext("No Contract") + "</option>").appendTo($changeContract);
                    $.each(responseText.contracts, function (contractID, contract) {
                        $("<option value='" + contractID + "'>" + contract + "</option>").appendTo($changeContract);
                    });
                    $("#changeContractDialog").show().undelegate("#changeContractButton", "click").delegate("#changeContractButton", "click", function () {
                        params += "&changeContract=" + $("#changeContract").val();
                        $(this).attr("params", params);
                    });
                    prepareDocument($("#changeContractDialog"));
                }
            });
        } else if ($(this).hasClass("changeServiceStartDate")) {
            var params = "updateServiceStartDate=1";
            if ($(this).attr("id")) {
                params += "&" + type + "[]=" + $(this).attr("id");
            }
            $("#changeServiceStartDate").html("");
            $("#changeServiceStartDateDialog").show().undelegate("#changeServiceStartDateButton", "click").delegate("#changeServiceStartDateButton", "click", function () {
                params += "&changeServiceStartDate=" + $("#changeServiceStartDate").val();
                $(this).attr("params", params);
            });
            prepareDocument($("#changeServiceStartDateDialog"));
        } else if ($(this).hasClass("changeServiceDates")) {
            var params = "updateServiceDates=1";
            if ($(this).attr("id")) {
                params += "&" + type + "[]=" + $(this).attr("id");
            }
            var data = "getAssetTypeServiceLevels=true";
            if ($(this).attr("id")) {
                data += "&assetIDs[]=" + $(this).attr("id");
            } else {
                $("[name='assets[]']:checked", context).each(function (index, item) {
                    data += "&assetIDs[]=" + $(item).val();
                });
            }
            $.ajax({
                type: "POST",
                url: "/common/ajax/searchPages.php",
                data: data,
                dataType: "json",
                success: function (responseText, statusText, xhr, $form) {
                    $("#changeServiceDatesDiv").html("");
                    if (responseText.assetTypeServiceLevels && responseText.assetTypeServiceLevels.constructor === Array) {
                        $("<div class='row'><div class='span12'>" + gettext('No service levels found for these Assets.') + "</div></div>").appendTo($("#changeServiceDatesDiv"));
                        $("#changeServiceDatesButton").hide();
                    } else if (responseText.assetTypeServiceLevels) {
                        $("#changeServiceDatesButton").show();
                        $.each(responseText.assetTypeServiceLevels, function (assetTypeID, assetType) {
                            $("<div class='row'><div class='span12'><h3>" + assetType.assetTypeName + "</h3></div></div>").appendTo($("#changeServiceDatesDiv"));
                            var newRow = $('<div class="row"></div>');
                            newRow.appendTo($("#changeServiceDatesDiv"));
                            $.each(assetType.serviceLevels, function (serviceLevelID, serviceLevelName) {
                                let dataCy = "Date_Dialog_" + assetType.assetTypeName + "_" + serviceLevelName;
                                dataCy = dataCy.replace(' ', '_');
                                $("<div class='span6'><span class='fieldHeader'>" + serviceLevelName + "</span><div class='groupedInput'><input type='text' data-cy='" + dataCy + "' placeholder='" + gettext('No Change') + "' name='changeServiceDates[" + assetTypeID + "][" + serviceLevelID + "]' class='datePicker' /></div></div>").appendTo(newRow);
                            });
                        });
                    }

                    $("<div class='clear'></div>").appendTo($("#changeServiceDatesDiv"));
                    $("#changeServiceDatesDialog").show().undelegate("#changeServiceDatesButton", "click").delegate("#changeServiceDatesButton", "click", function () {
                        $("#changeServiceDatesDiv").find("input").each(function (index, item) {
                            if ($(item).val() != "") {
                                params += "&" + $(item).attr("name") + "=" + $(item).val();
                            }
                        });
                        $(this).attr("params", params);
                    });
                    prepareDocument($("#changeServiceDatesDialog"));
                }
            });
        } else if ($(this).hasClass("removeServiceLevels")) {
            var params = "removeServiceLevels=1";
            if ($(this).attr("id")) {
                params += "&" + type + "[]=" + $(this).attr("id");
            }
            var data = "getAssetServiceLevels=true";
            var assetIDs = new Array();
            if ($(this).attr("id")) {
                data += "&assetIDs[]=" + $(this).attr("id");
                assetIDs.push($(this).attr("id"));
            } else {
                $("[name='assets[]']:checked", context).each(function (index, item) {
                    data += "&assetIDs[]=" + $(item).val();
                    assetIDs.push($(item).val());
                });
            }
            $.ajax({
                type: "POST",
                url: "/common/ajax/searchPages.php",
                data: data,
                dataType: "json",
                success: function (responseText, statusText, xhr, $form) {
                    var removeServiceLevelsDiv = $("#removeServiceLevelsDiv");
                    removeServiceLevelsDiv.html("");
                    if (responseText.assetServiceLevels && responseText.assetServiceLevels.constructor === Array) {
                        $("<div class='row'><div class='span12'>" + gettext("Cannot remove service levels because the assets are either using the parent's service levels or do not have any service levels.") + "</div></div></br>").appendTo(removeServiceLevelsDiv);
                        $("#removeServiceLevelsButton, #removeServiceLevelsContractDiv").hide();
                    } else if (responseText.assetServiceLevels) {
                        $("<div class='row'><div class='span12 lightBold halfMarginBottom'>" + gettext('Please select the Service Level(s) to be removed from the selected assets:') + "</div></div>").appendTo(removeServiceLevelsDiv);
                        $("#removeServiceLevelsButton, #removeServiceLevelsContractDiv").show();
                        if (assetIDs.length === 1) {
                            $("#removeServiceLevelsContractDiv").hide();
                            $("input[name='excludeContracts']").prop("checked", false);
                        } else {
                            $("input[name='excludeContracts']").prop("checked", true);
                        }
                        var serviceLevelOptions = '';
                        $.each(responseText.assetServiceLevels, function (service_level_id, serviceLevel) {
                            serviceLevelOptions += '<div class="row"><div class="span12"><label><input data-cy="Remove_Service_Levels_' + serviceLevel.service_level_name + '" type="checkbox" id="' + service_level_id + '" name="removeServiceLevels[' + service_level_id + ']" value="' + assetIDs + '">' + serviceLevel.service_level_name + (serviceLevel.removed ? ' ' + gettext('(Archived)') : '') + '</label></div></div>';
                        });
                        $(serviceLevelOptions).appendTo(removeServiceLevelsDiv);
                    }
                    $("<div class='clear'></div>").appendTo(removeServiceLevelsDiv);
                    $("#removeServiceLevelsDialog").show().undelegate("#removeServiceLevelsButton", "click").delegate("#removeServiceLevelsButton", "click", function () {
                        removeServiceLevelsDiv.find("input").each(function (index, item) {
                            if ($(item).is(":checked")) {
                                params += "&" + $(item).attr("name") + "=" + $(item).val();
                            }
                        });
                        $(this).attr("params", params);
                    });
                    prepareDocument($("#removeServiceLevelsDialog"));
                }
            });
        } else if ($(this).hasClass("createGroup") || $(this).hasClass("createSubgroup") || $(this).hasClass("editGroup") || $(this).hasClass("editSubgroup")) {
            var params = "";
            var dialog = $(this).parents(".divForm").find(".createGroupDialog");
            dialog.find(".create, .edit, .group, .subgroup").hide();
            if ($(this).hasClass("createGroup")) {
                dialog.find(".create, .group").show();
                params += "createGroup";
            } else if ($(this).hasClass("createSubgroup")) {
                dialog.find(".create, .subgroup").show();
                params += "createSubgroup";
            } else if ($(this).hasClass("editGroup")) {
                dialog.find(".edit, .group").show();
                params += "editGroup";
            } else {
                dialog.find(".edit, .subgroup").show();
                params += "editSubgroup";
            }
            params += "=true";
            if ($(this).attr("id")) {
                params += "&groupID=" + $(this).attr("id");
            }
            var textfield = dialog.find(".groupName");
            textfield.val($(this).attr("value")).focus();
            checkMandatoryMarker();
            dialog.show().undelegate(".createGroupButton", "click").delegate(".createGroupButton", "click", function () {
                params += "&groupName=" + encodeURIComponent(textfield.val());
                $(this).attr("params", params);
            });
            textfield.focus();
        } else if ($(this).hasClass("setGroupMarkup") || $(this).hasClass("setSubgroupMarkup")) {
            var params = "";
            var theDialog = $("#setGroupMarkupDialog");
            theDialog.find(".group, .subgroup").hide();
            if ($(this).hasClass("setGroupMarkup")) {
                theDialog.find(".edit, .group").show();
                params += "editGroupMarkup";
            } else if ($(this).hasClass("setSubgroupMarkup")) {
                theDialog.find(".edit, .subgroup").show();
                params += "editSubgroupMarkup";
            }
            params += "=true&groupID=" + $(this).attr("id");
            // reset the dialog
            serviceMarkup = theDialog.find("#pricingTierDefaultMarkup");

            if (serviceMarkup.length > 0) {
                theDialog.find("#markup").val(serviceMarkup.val());
            } else {
                theDialog.find("#markup").val("");
            }
            theDialog.undelegate("#useDefaultMarkup", "change").delegate("#useDefaultMarkup", "change", function () {
                theDialog.find("#markup").prop('disabled', $(this).prop('checked'));
                if ($(this).prop('checked')) {
                    var defaultMarkup = theDialog.find('#pricingTierID option:selected, input#pricingTierID').data('defaultmarkup');
                    if (typeof defaultMarkup !== "undefined") {
                        theDialog.find("#markup").val(defaultMarkup);
                    }
                }
            });
            theDialog.undelegate("#pricingTierID", 'change').delegate("#pricingTierID", "change", function () {
                if (theDialog.find("#useDefaultMarkup").prop('checked')) {
                    var defaultMarkup = theDialog.find('#pricingTierID option:selected').data('defaultmarkup');
                    if (typeof defaultMarkup !== "undefined") {
                        theDialog.find("#markup").val(defaultMarkup);
                    }
                }
            }).undelegate("button", 'click').delegate('button', 'click', function () {
                theDialog.find('.dialogErrorMessage').remove();
            });
            theDialog.find("#useDefaultMarkup").prop('checked', false).trigger('change');

            theDialog.show().undelegate("#setGroupMarkupButton", "click").delegate("#setGroupMarkupButton", "click", function () {
                if (!checkMandatory($('#setGroupMarkupDialog'))) {
                    return false;
                }
                if (theDialog.find('#useDefaultMarkup').prop('checked')) {
                    params += "&useDefaultMarkup=true";
                } else {
                    params += "&markup=" + theDialog.find("#markup").val();
                }
                params += "&pricingTierID" + theDialog.find("#pricingTierID").val();
                $(this).attr("params", params);
            });

        } else if ($(this).hasClass("setGroupSuppliers") || $(this).hasClass("setSubgroupSuppliers")) {
            var params = "";
            var isGroup = $(this).hasClass("setGroupSuppliers");
            var groupID = $(this).attr("id");
            var data = "getSuppliers=true&" + type + "=true&";
            if (isGroup) {
                data += "groupID=" + groupID;
                params += "setGroupSuppliers";
            } else {
                isSubgroup = true;
                data += "subGroupID=" + groupID;
                params += "setSubgroupSuppliers";
            }
            params += "=true&groupID=" + $(this).attr("id");
            $.ajax({
                type: "POST",
                url: "/common/ajax/searchPages.php",
                data: data,
                dataType: "json",
                success: function (responseText, statusText, xhr, $form) {
                    var groupsDialog = $("#setGroupSuppliersDialog");
                    groupsDialog.find(".group, .subgroup").hide();
                    if (isGroup) {
                        groupsDialog.find(".edit, .group").show();
                    } else {
                        groupsDialog.find(".edit, .subgroup").show();
                    }

                    // Set available suppliers
                    var availableSuppliers = groupsDialog.find("#availableSuppliers");
                    $(availableSuppliers).html("");
                    $.each(responseText.availableSuppliers, function (supplierID, supplierName) {
                        $("<option value='" + supplierID + "'>" + supplierName + "</option>").appendTo(availableSuppliers);
                    });
                    $(availableSuppliers).suggestselect("refresh")

                    // Set assigned suppliers
                    var assignedSuppliers = groupsDialog.find("#assignedSuppliers");
                    $(assignedSuppliers).html("");
                    $.each(responseText.assignedSuppliers, function (supplierID, supplierName) {
                        var newSupplier = $("#newSupplier").clone().removeClass("hide");
                        $(newSupplier).find("span.fieldHeader").text(supplierName);
                        $(newSupplier).find("input[type='text']").attr("name", "suppliers[" + supplierID + "]");
                        $(newSupplier).find("input[type='checkbox']").attr("name", "addAll[" + supplierID + "]");
                        $(newSupplier).appendTo(assignedSuppliers);
                    });

                    // Add new supplier
                    groupsDialog.undelegate("#addSupplier", "click").delegate("#addSupplier", "click", function () {
                        var selectedSupplier = $(availableSuppliers).find("option:selected");
                        if (selectedSupplier.exists()) {
                            var newSupplier = $("#newSupplier").clone().removeClass("hide");
                            $(newSupplier).find("span.fieldHeader").text(selectedSupplier.text());
                            $(newSupplier).find("input[type='text']").attr("name", "suppliers[" + selectedSupplier.val() + "]");
                            $(newSupplier).find("input[type='checkbox']").attr("name", "addAll[" + selectedSupplier.val() + "]").prop('checked', true);
                            $(newSupplier).appendTo(assignedSuppliers);
                            $(selectedSupplier).remove();
                            $(availableSuppliers).suggestselect("refresh");
                        }
                    });

                    groupsDialog.show().undelegate("#setGroupSuppliersButton", "click").delegate("#setGroupSuppliersButton", "click", function () {
                        $(assignedSuppliers).find("input").each(function (index, item) {
                            if (!$(item).is(':checkbox') || $(item).prop('checked')) {
                                params += "&" + $(item).attr("name") + "=" + $(item).val();
                            }
                        });
                        $(this).attr("params", params);
                    });
                }
            });
        } else if ($(this).hasClass("archive")) {
            var divForm = $(this).parents(".divForm");
            var ok = true;
            if ($(this).parents(".optionsPanel").exists()) {
                // link at bottom for multiple items
                var items = divForm.find(".resultsTable input:checked");
                if (!items.exists()) {
                    ok = false;
                }
            }
            if (ok) {
                var dialog = divForm.find(".archiveDialog");
                dialog.find(".message").html($(this).attr("value"));
                dialog.show();
                $(".archiveButton", dialog).attr("params", $(this).attr("params"));
            }
        } else if ($(this).hasClass("plantCheckIn")) {
            var plantIdHiddenField = $("#checkInDialog input[name='checkInPlantID']");
            if (typeof $(this).data("plantid") !== 'undefined') {
                plantIdHiddenField.val($(this).data("plantid"));
            } else {
                plantIdHiddenField.val("");
            }
            $("#checkInDialog").show();
        } else if ($(this).hasClass("plantCheckOut")) {
            var plantIdHiddenField = $("#checkOutDialog input[name='checkOutPlantID']");
            if (typeof $(this).data("plantid") !== 'undefined') {
                plantIdHiddenField.val($(this).data("plantid"));
            } else {
                plantIdHiddenField.val("");
            }
            $("#checkOutDialog").show();
        } else if ($(this).hasClass("setQuoteOrderNo") || $(this).hasClass("convertJobs")) {
            openSetQuoteOrderNoDialog(this);
        }
    }).delegate(".archiveEmployee, .deleteEmployee", "click", function () {
        var id = $(this).attr("id");
        $("#reassignID").find("option").removeClass("hide").end().find("option[value='" + id + "']").addClass("hide").end();
        if ($(this).hasClass("deleteEmployee")) {
            $.ajax({
                type: "POST",
                url: "/common/ajax/searchPages.php",
                data:  "checkHistory=true&employees=true&id=" + id,
                dataType: "json",
                success: function (responseText, statusText, xhr, $form) {
                    if (responseText.checkHistory == true) {
                        $("#deleteButton").hide();
                    } else {
                        $("#deleteButton").show();
                    }
                    $("#deleteDialog").show();
                }
            });
        } else {
            $("#deleteButton").hide();
            $("#deleteDialog").show();
        }
        $("#archiveButton").off().on("click", function () {
            ajaxSubmit($(this), "employeesID=" + id + "&archive=true&reassignID=" + $("#reassignID").val());
        });
        $("#deleteButton").off().on("click", function () {
            ajaxSubmit($(this), "employeesID=" + id + "&delete=true&reassignID=" + $("#reassignID").val());
        });
        $("#archivePseudoButton").off().on("click", function () {
            ajaxSubmit($(this), "employeesID=" + id + "&archive=true&pseudonymise=true&reassignID=" + $("#reassignID").val());
        });
    }).delegate(".applyPayment", "click", function () {
        $('<form method="post" action="editPayment.php"></form>')
            .append($("input[name='unpaid[]']")
            .clone()
            .attr("name", "invoiceIDs[]"))
            .appendTo('body')
            .submit()
            .remove();
    }).delegate(".invoiceWorkOrders", "click", function () {
        if ($(this).hasClass("retention")) {
            $('<form method="post" action="editContractorInvoice.php?retentionClaim=1"></form>')
                .append($("input[name='retentions[]']")
                    .clone()
                    .attr("name", "contJobID[]"))
                .appendTo('body')
                .submit()
                .remove();
        } else {
            $('<form method="post" action="editContractorInvoice.php"></form>')
                .append(
                    $("input[name='pending[]'],input[name='approved[]'],input[name='complete[]']")
                    .clone()
                    .attr("name", "contJobID[]")
                )
                .appendTo('body')
                .submit()
                .remove();
        }
    }).delegate(".createTransfer", "click", function () {
        $('<form method="post" action="stockTransfer.php?new=true"></form>')
            .append($("<input type='hidden' name='storageID' />").val($("select[name='storageID']").val()))
            .append($("<input type='hidden' name='destinationStorageID' />").val($("select[name='destinationStorageID']").val()))
            .append($("input[name='stock[]']").clone().each(function () {
                $(this).val($(this).val().replace(/^[0-9]+\|/, ''))
            }))
            .appendTo('body')
            .submit()
            .remove();
    }).delegate(".restockSelect", 'change', function () {
        console.log('restockSelect::change');
        $('.restockCurrency').toggle($(this).val() == 'order' || $(this).val() == 'quote');
    }).delegate(".restockBtn", "click", function () {
        var stock = $('select[name="restockType"]').val();
        if (/^[0-9]+$/.test(stock)) {
            $('<form method="post" action="stockTransfer.php?new=true"></form>')
                .append($("<input type='hidden' name='destinationStorageID' />").val($("select[name='storageID']").val()))
                .append($("<input type='hidden' name='storageID' />").val(stock))
                .append($("<input type='hidden' name='restock' value='true' />"))
                .appendTo('body')
                .submit()
                .remove();
        } else if (stock == 'order') {
            $('<form method="post" action="supplierOrder.php?newOrder=true"></form>')
                .append($("<input type='hidden' name='restock' />").val($("select[name='storageID']").val()))
                .append($("<input type='hidden' name='restockCurrency' />").val($("input[name='restockCurrency'], select[name='restockCurrency']").val()))
                .appendTo('body').submit().remove();
        } else if (stock == 'quote') {
            $('<form method="post" action="supplierOrderQuote.php?newSupplierQuote=true"></form>')
                .append($("<input type='hidden' name='restock' />").val($("select[name='storageID']").val()))
                .append($("<input type='hidden' name='restockCurrency' />").val($("input[name='restockCurrency'], select[name='restockCurrency']").val()))
                .appendTo('body').submit().remove();
        }
    }).delegate(".allocateToJob", "click", function () {
        $('<form method="post" action="stockAllocation.php?new=true"></form>')
            .append($("<input type='hidden' name='storageID' />").val($("select[name='storageID']").val()))
            .append($("input[name='stock[]']").clone().each(function () {
                $(this).val($(this).val().replace(/^[0-9]+\|/, ''))
            }))
            .appendTo('body').submit().remove();
    }).delegate(".openConvertLeadDialog", "click change", function () {
        var dialog = $("#convertLeadDialog");
        let $this = $(this);
        if ($(this).hasClass("suggestSelect")) {
            $this = $(this).find(":selected");
        }
        let projectType = $this.data('projecttype');
        let projectID = $this.data('projectid');
        if (projectType === 'job') {
            $('.convertToJob-js', dialog).show();
            $('.convertToQuote-js', dialog).hide();
            $('.convertLeadDialogOkBtn', dialog).data('projecttype', 'job').show();
        } else {
            $('.convertToQuote-js', dialog).show();
            $('.convertToJob-js', dialog).hide();
            $('.convertLeadDialogOkBtn', dialog).data('projecttype', 'quote').hide();
        }

        var customerList = $('.customerList, .singleCustomerList, .convertLeadDialogPrimary, .additionalCustomerList', dialog);
        // initialise dialog
        $('.closeLead', dialog).val(1);
        $('.convertLeadDialogMulti', dialog).val(-1);
        $('.multipleOptions, .nonMultipleOptions ', dialog).hide();
        customerList.empty();
        dialog.data('projectid', projectID);
        dialog.data('projecttype', $this.data('projecttype'));
        $.ajax({
            type: "POST",
            url: "../common/ajax/leads.php",
            data: "getAdditionalCustomers=" + projectID,
            dataType: "json",
            success: function (responseText, statusText, xhr, $form) {
                $.each(responseText, function (i, item) {
                    customerList.append(new Option(item.name, item.userID));
                });
                $(".convertLeadDialogPrimary").suggestselect("setValue", -1);
                if (projectType === 'quote') {
                    $(".customerList").suggestselect("setValue", -1);
                } else {
                    //need to set this, so that the dropdown shows a value already selected when dialog loads
                    $(".singleCustomerList").suggestselect("setValue", -1);
                }
            }
        });
        prepareDocument(dialog);
        dialog.show().undelegate(".dialogClose", "click").delegate(".dialogClose", "click", function() {
            // if Cancel, change option back to "Choose One".
            $('#convertTo').suggestselect("setValue", -1);
        });
        return false;
    }).delegate(".convertLeadDialogMulti", 'change', function () {
        var dialog = $("#convertLeadDialog");
        $('.multipleOptions, .nonMultipleOptions, .convertLeadDialogOkBtn', dialog).hide();
        if ($(this).val() != '-1') {
            if ($(this).val() == '1') {
                $('.multipleOptions', dialog).show();
            } else if ($(this).val() == '0') {
                $('.nonMultipleOptions', dialog).show();
            }
            $('.convertLeadDialogOkBtn', dialog).show();
        }
        return false;
    }).delegate(".convertLeadDialogPrimary", 'change', function () {
        showLoadingImage();
        var dialog = $("#convertLeadDialog");
        var customerList = $('.additionalCustomerList', dialog);
        customerList.empty();
        let projectID = $("#convertLeadDialog").data('projectid');
        dialog.data('projectid', projectID);
        $.ajax({
            type: "POST",
            url: "../common/ajax/leads.php",
            data: "getAdditionalCustomers=" + projectID,
            dataType: "json",
            success: function (responseText, statusText, xhr, $form) {
                $.each(responseText, function (i, item) {
                    customerList.append(new Option(item.name, item.userID));
                });
                hideLoadingImage();
            },
            error: function (data) {
                let txtMessage = gettext('Retrieval of Additional Customers failed');
                createDialog("alert", txtMessage, gettext("Additional Customers"));
                hideLoadingImage();
            }
        });
        prepareDocument(dialog);
    }).delegate(".convertLeadDialogOkBtn", "click", function () {
        const projectType = $(this).data('projecttype');
        var dialog = $("#convertLeadDialog");
        var data = 'convert=' + String(projectType) + '&convertDialogProjectID=' + dialog.data('projectid');
        data += '&multiple=' + $('.convertLeadDialogMulti', dialog).val();
        data += '&close=' + $('.closeLead', dialog).val();
        if (projectType === 'quote') {
            if ($(".convertLeadDialogMulti", dialog).val() == '1') {
                var selectedList = $(".customerList option:selected", dialog);
                if (selectedList.length > 0) {
                    selectedList.each(function () {
                        data += '&customers[]=' + $(this).val();
                    });
                    ajaxSubmit($(this), data);
                }
            } else if ($(".convertLeadDialogMulti", dialog).val() == '0') {
                data += '&primary=' + $(".convertLeadDialogPrimary", dialog).val();
                var selectedList = $(".additionalCustomerList option:selected", dialog);
                if (selectedList.length > 0) {
                    selectedList.each(function () {
                        data += '&customers[]=' + $(this).val();
                    });
                }
                ajaxSubmit($(this), data);
            }
        } else {
            var selectedList = $(".singleCustomerList option:selected", dialog);
            if (selectedList.length > 0) {
                selectedList.each(function () {
                    data += '&primary=' + $(this).val();
                });
                ajaxSubmit($(this), data);
            }
        }
        return false;
    }).delegate(".dialogConfirmChkAdditionalCustomers", "click", function () {
        var thisLink = $(this);
        var checkBoxName = $(this).data('checkboxname');
        var divForm = $(this).parents(".divForm:first:visible");
        var hasMultiCustomer = false;
        $('input[name^=\'' + checkBoxName + '[]\']:checked', divForm).each(function (i, item) {
            if ($(item).parents('tr:first').find('.multicustomer').length > 0) {
                hasMultiCustomer = true;
                return;
            }
        });
        if (hasMultiCustomer) {
            createDialog("alert", gettext("The action cannot be performed because one or more of the items in your selection contains additional customers."), gettext("Warning"));
        } else {
            createDialogConfirm(thisLink, true);
        }
        return false;
    }).delegate(".openConvertQuoteDialog", "click change", renderQuoteConvertDialog

    ).delegate(".convertQuoteDialogOkBtn", "click", function () {
        showLoadingImage();
        var dialog = $("#convertQuoteDialog");
        if (!checkMandatory(dialog)) {
            hideLoadingImage();
            return false;
        }
        var datas = 'convert=true&convertDialogProjectID=' + dialog.data('projectid') + "&convertType=" + dialog.data('projecttype') + "&openHash=" + dialog.data('openhash');
        datas += '&customer=' + $(".customerList", dialog).val();
        let dialogOrderNo = $("#dialogOrderNo", dialog).val();
        if ($(".orderNoNeeded").is(':visible')) {
            datas += '&dialogOrderNo=' + dialogOrderNo;
        }
        datas += '&close=' + $(".closeQuote", dialog).val();
        doConvert(datas);
    }).delegate(".confirmConvertQuote", "change", function () {
        showLoadingImage();
        let $this = $(this);
        let $selected = $this.children("option:selected");
        if ($this.hasClass("dialogConfirm")) {
            // Show confirm screen handled by dialogConfirm event
            hideLoadingImage();
        } else {
            let datas = $selected.attr('params');
            doConvert(datas);
        }
    }).delegate(".confirmConvertQuoteMenu", "click", function () {
        showLoadingImage();
        let $this = $(this);
        if ($this.hasClass("dialogConfirm")) {
            // Show confirm screen handled by dialogConfirm event
            hideLoadingImage();
        } else {
            let datas = $this.attr('params');
            doConvert(datas);
        }
    }).delegate(".setQuoteOrderNo", "change", function () {
        if ($(this).hasClass('confirmConvertQuoteMenu')) {
            // don't do this again if this class exists
        } else {
        openSetQuoteOrderNoDialog($(this).find(":selected"));
        }
    }).delegate("#menuMarkPaid, #optionsMarkPaid", "click", function () {
        params="paid=true";
        if($(this).attr('id') === 'menuMarkPaid'){
            var invID = $(this).attr('rel');
            params += "&invoiceID=" + invID;
        }
        $defaultDate = $('#datePaid').attr('default');
        $('#datePaid').val($defaultDate);
        $('#markPaidButton').attr('params', params);
        $('#markPaidDialog').show();
    }).delegate('input[name="plants[]"]', "change", function () {
        //for page plants.php
        var totalPlantTypeRemoved = 0;
        var totalChecks = $('input[name="plants[]"]').filter(':checked');
        totalChecks.each(function() {
            if ($(this).closest('tr').find(':last-child .singlePlant').attr("data-plantTypeRemoved")) {
                totalPlantTypeRemoved ++;
            }
        });
        if (totalPlantTypeRemoved) {
            if (totalPlantTypeRemoved == 1 && totalChecks.length == 1) {
                $('.multiplePlants').attr('value', gettext("Plant type of item selected has been archived. By continuing, the Plant Type will also be made active along with the Plant Item."));
            } else if (totalPlantTypeRemoved == 1 && totalChecks.length > 1) {
                $('.multiplePlants').attr('value', gettext("One of the items selected has Plant Type that have been archived. By continuing, the Plant Type will also be made active along with the Plant Item."));
            } else if (totalPlantTypeRemoved > 1) {
                $('.multiplePlants').attr('value', gettext("More than one of the items selected have Plant Types that have been archived. By continuing, the Plant Types will also be made active along with the Plant Items."));
            }
        } else {
            if (totalChecks.length == 1) {
                $('.multiplePlants').attr('value', gettext("Are you sure you want to reactivate this plant"));
            } else {
                $('.multiplePlants').attr('value', gettext("Are you sure you want to reactivate these plants ?"));
            }
        }
    }).delegate(".confirmConvertLead", "change", function () {
        let $this = $(this);
        if ($this.hasClass("dialogConfirm")) {
            // Show confirm screen handled by dialogConfirm event
            hideLoadingImage();
        } else {
            let $selected = $this.children("option:selected");
            doConvertLead($selected.attr('params'));
        }
    }).delegate(".checkAssetDefectExists-js", "click", function (e) {
        e.preventDefault();
        let $this = $(this);
        if ($this.data('clicked')) return;
        if ($this.data('type') !== undefined) {
            const type = $this.data('type');
            let selectedValues = $('input[name="' + type + '[]"]:checked').map(function() {
                return $(this).val();
            }).get();
            projectIDs = selectedValues.join(',');
        } else {
            projectIDs = $this.data('project-id');
        }
        let projectType = $this.data('is-quote'), bulkAction = $this.data('bulk-action'), action = $this.data('action');
        $this.data('clicked', true);
        $.ajax({
            type: "GET",
            data: {
                projectIDs,
                projectType,
                action,
                bulkAction
            },
            url: "/common/ajax/searchPages.php",
            dataType: "json",
            success: function (response) {
                if (response.success) {
                    if (response.message !== '') {
                        $this.attr('value', response.message);
                    }
                    if (action === 'archive') {
                        $this.addClass('archive');
                        $this.trigger('click');
                        $this.data('clicked', false);
                        $this.removeClass('archive');
                    } else if (action === 'delete') {
                        if (!bulkAction) {
                            $this.addClass('dialogConfirm ajaxClick').trigger('click');
                        } else {
                            const params = $this.attr("params");
                            const dialog = createDialog(
                                'confirm',
                                $this.attr('value'),
                                gettext('Confirm')
                            );
                            dialog.delegate('.dialogContinue', 'click', function () {
                                showLoadingImage();
                                dialog.remove();
                                const divForm = $(".divForm:visible");
                                ajaxSubmit(divForm, params);
                            });
                            $this.data('clicked', false);
                        }
                    }
                } else {
                    createDialog("alert", response.message, gettext("Error"));
                    $this.data('clicked', false);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                createDialog("alert", response.message, gettext("Error"));
                $this.data('clicked', false);
            }
        });
    });

    $('.resetGlobalSearch').click(function () {
        $('#globalSearch').val('');
        $('#globalSearch').prev().removeClass('hide');
    });
});

function doConvert(datas) {
    $.ajax({
        type: "POST",
        url: "../common/ajax/projects/convert.php",
        data: datas,
        dataType: "json",
        success: function (responseText) {
            if (responseText.success) {
                window.location.href = responseText.redirectURL;
            } else {
                $("#convertQuoteDialog").hide(); // hide the existing dialog box
                createDialog("alert", responseText.message, gettext('Quote Convert Failed'));
                $('#convertTo').suggestselect("setValue", '-1'); // set the convert option back to please select
            }
            hideLoadingImage();
        },
        error: function (data) {
            createDialog("alert", "<div class='row dialogErrorMessage'><div class='span12'><div class='warning'>" + responseText.message + "</div></div></div>", gettext("Conversion Error"));
            hideLoadingImage();
        }
    });
}

 /**
  * Handles param when converting quote requiring order no.
  * @param {Object} element
  */
function openSetQuoteOrderNoDialog(element) {
    let params = $(element).attr("params");
    let theDialog = $("#setQuoteOrderNoDialog");
    if ($(element).data("optcostcentres") == 1) {
        $("#dialogMessageOptCostCentre").removeClass("hide");
    }
    let quoteId = $(element).data("quote-id");
    $("#dialogQuoteID").html(quoteId);
    theDialog
        .show()
        .undelegate("#setQuoteOrderNoButton", "click")
        .delegate("#setQuoteOrderNoButton", "click", function () {
        if (!checkMandatory($('#setQuoteOrderNoDialog'))) {
            return false;
        }
            let dialogOrderNo = $("#dialogOrderNo").val();
            if (typeof dialogOrderNo != "undefined") {
                params += "&dialogOrderNo=" + dialogOrderNo;
            }
        params += "&convertDialogProjectID=" + quoteId;
            $(this)
                .attr("params", params)
                .removeClass('ajaxClick')
                .addClass('confirmConvertQuoteMenu');
        });
    theDialog
        .undelegate(".dialogClose", "click")
        .delegate(".dialogClose", "click", function() {
        // if Cancel, change option back to "Choose One".
        $('#convertTo').suggestselect("setValue", -1);
    });
}
resultLinkedItems = new Array();
function addResultItems() {
    var items = $('.itemField').filter(":visible").filter(function () {
        return this.value;
    });
    if (items.exists()) {
        if (validResultItems(items)) {
            window.setTimeout(function () {
                $("<div id='loadingItems' style='display:none'><div class='lightBox'><span class='icon-tick'></span> " + gettext('Items Added') + "</div></div>").appendTo("body").fadeIn("2000", function () {
                    $(this).fadeOut("300", function () {
                        $(this).remove();
                    });
                });
            }, 1);
            var params = "";
            resultLinkedItems = new Array();
            items.each(function () {
                if ($(this).hasClass("linkedItems")) {
                    resultLinkedItems.push($(this).attr("id"));
                }
                params += "&" + $(this).attr("name") + "[" + $(this).attr("id") + "]=" + $(this).val();
                let $tr = $(this).closest('tr');
                if (!$tr.hasClass('noQuantityHighlight')) {
                    let $td = $tr.find('td');
                    let currentQuantity = $td.data('current-quantity') ? parseFloat($td.data('current-quantity')) : 0;
                    let newQuantity = currentQuantity + $(this).getNumber();
                    $td.data('current-quantity', newQuantity);
                    $td.data('title-temporary', 1);
                    $td.attr('title', sprintf('Current Quantity: %s', $('<input>').val(newQuantity).numberFormat().val()));
                    $tr.addClass('textBold');
                }
                $(this).val('');
            });
            if (params != "") {
                if (window.addItems) {
                    addItems(params, resultLinkedItems.length > 0 ? 'showLinkedItems' : null);
                }
            }
            $("#searchText:visible").select().focus();
        }
    } else {
        createDialog("alert", gettext("Please enter a quantity below to add an item."), gettext("Warning"));
    }
}

function validResultItems(items) {
    var invalidItems = false;
    $("#uomDialogList").children().remove();

    //Checking quantities

    items.each(function () {
        if ($(this).data("wholeitemonly") == "1") {
            var intVal = parseInt($(this).parseNumber());
            if ($(this).parseNumber() - intVal != 0) {
                $("#uomDialogList").append("<li>" + $(this).data("name") + "</li>");
                invalidItems = true;
            }
        }
    });

    if (invalidItems) {
        $("#uomDialog").show();
    }

    return !invalidItems;
}

/**
 * Used for catalogue searches
 */
function showLinkedItems() {
    var dialog = $("#linkedItemsDialog");
    var params = "";
    for (i = 0; i < resultLinkedItems.length; i++) {
        params += "&linkedItem[]=" + resultLinkedItems[i];
    }
    dialog.find(".resetSearch").attr("params", params);
    dialog.show();
}

/**
 * Used for quick add item searches
 */
let linkedItems = null;
let linkedItemsDialog = false;
function initialiseLinkedItems(element) {
    if (element.linkedItems) {
        linkedItemsDialog = true;
        linkedItems = element.linkedItems;
    }
}
function checkLinkedItems() {
    if (linkedItemsDialog === true) {
        let dialogContent = '';
        dialogContent += '<p>' + gettext('This item has linked items.  Would you like these linked items displayed so they may be added as well?') + '</p>';
        dialogContent += '<div class="hCenter">';
        dialogContent += '  <button type="button" class="btnBlue" id="displayLinkedItems">' + gettext('Show Linked Items') + '</button>';
        dialogContent += '  <button type="button" class="btnGrey dialogClose">' + gettext('Cancel') + '</button>';
        dialogContent += '</div>';
        let linkedDialogue = createDialog('custom', dialogContent, gettext('Linked Items Found'), null, true);
        $('#displayLinkedItems')
            .one('click', function () {
                linkedDialogue.remove();
                linkedItemsDialog = false;
                showLinkedItemsSuggestions();
            });
    }
    if (linkedItems !== null && !linkedItemsDialog) {
        showLinkedItemsSuggestions();
    }
}

function showLinkedItemsSuggestions() {
    let $searchQuickItem = $("input[name='searchQuickItem']");
    $searchQuickItem.attr('filter-includeids', linkedItems);
    $searchQuickItem.suggestselect('search', '', true);
    $searchQuickItem.one('click', function() {
        $(this).removeAttr('filter-includeids').suggestselect('search', '', true);
        linkedItems = null;
    });
}
function updateDetailResult(response) {
    var detailID = $(response).find("#detailsID");
    if (detailID.exists()) {
        var divForm = $('#divForm' + detailID.val());
        var container = divForm.parent().parent().prev();
        if (divForm.exists()) {
            divForm.parent().parent().remove();
        }
        container.find(".detailedResults").trigger('click');
    }
}
function edit_storage_device(storageID) {
    $('#editDeviceDialog input[name="deviceID"]').val(storageID);
    $('#editDeviceDialog input[name="storageName"]').val($('#storage_name_' + storageID).val());
    let hasDefaultDevice = $('#storage_default_' + storageID).val() == "1";
    $('#editDeviceDialog input[name="defaultDevice"]').prop('checked', hasDefaultDevice).prop('disabled', hasDefaultDevice);
    $('#currentDefaultDevice').val(hasDefaultDevice);
    $('#editDeviceDialog').show();
}

function searchCallback() {
    storeBackButton();
    autoFocus();
}

function selectDefaultSubgroup() {
    if ($("#moveGroupID").val() == -1) {
        //if group is "No Group", subgroup should be "None"
        $("#moveSubgroupID").suggestselect("setValue", "-1");
    } else {
        //subgroup is "Please Select"
        $("#moveSubgroupID").suggestselect("setValue", "");
    }
}

/**
 * supplier order merge validation
 * @param item
 */
function supplierOrderMergeValidation(item) {
    let hasReceipts = false;
    let descriptionOrder = false;
    let suppliers = Array();
    let elements = Array();
    if (item.data('target')) {
        let divForm = item.closest(".divForm");
        $("input[name='" + item.data('target') + "[]']:checked", divForm).each(function () {
            let $menu = $('.merge#' + $(this).val());
            if ($menu.length === 0) {
                descriptionOrder = true;
            } else {
                elements.push($menu);
            }
        });
    } else {
        elements.push(item);
    }
    if (elements.length > 0) {
        $(elements).each(function () {
            if ($(this).data('has-receipts') === 1) {
                hasReceipts = true;
            }
            suppliers.push($(this).data('supplier-id'));
        });
    }
    if (suppliers.length > 1) {
        suppliers = jQuery.unique(suppliers);
    }
    let txtMessage = '';
    if (suppliers.length > 1 || (descriptionOrder && elements.length > 1)) {
        txtMessage = gettext('Selected order(s) must have the same supplier.') + '<br/>';
    }
    if (hasReceipts) {
        txtMessage += gettext('Selected order(s) must not have any receipts.') + '<br/>';
    }
    if (descriptionOrder) {
        txtMessage += gettext('Selected order(s) must not be description orders.') + '<br/>';
    }
    if (txtMessage) {
        createDialog("alert", txtMessage, gettext("Can Not Merge Order"));
        return false;
    }
    return suppliers[0];
}

function doConvertLead(params) {
    $.ajax({
        type: "GET",
        url: "editLead.php",
        data: params + '&ajaxCall=true',
        success: function (responseText, statusText, xhr, $form) {
            let redirectCookie = readCookie("ajaxRedirect");
            if (redirectCookie != null) {
                window.location.href = decodeURIComponent(redirectCookie);
            } else {
                $("#convertQuoteDialog").hide(); // hide the existing dialog box
                createDialog("alert", responseText.message, gettext('Lead Convert Failed'));
                $('#convertTo').suggestselect("setValue", '-1'); // set the convert option back to please select
                hideLoadingImage();
            }
        },
        error: function (data) {
            createDialog("alert", "<div class='row dialogErrorMessage'><div class='span12'><div class='warning'>" + data + "</div></div></div>", gettext("Conversion Error"));
            hideLoadingImage();
        }
    });
}

/**
 * A default updateResults function to override
 */
function updateResults() {}

function renderQuoteConvertDialog()
{
    showLoadingImage();
    let $this = $(this);
    let preventConvert = true;
    let $dialog = $('#convertQuoteDialog');
    let checkCustomerCredit = false;
    let optCostCentreMsgNeeded = false;
    let additionalCustomers = false;
    let orderNoNeeded = false;
    let searchUserID = -2;
    let quoteAmount = 0;
    if ($this.attr('id') === 'convertTo') {
        // Finish state page
        $this = $this.find(':selected');
    }

    if ($this.hasClass('openConvertQuoteDialog')) {
        checkCustomerCredit = $this.hasClass('checkCustomerCredit');
        optCostCentreMsgNeeded = $this.hasClass('optCostCentreMsgNeeded');
        additionalCustomers = $this.hasClass('additionalCustomers');
        orderNoNeeded = $this.hasClass('orderNoNeeded');

        searchUserID = $this.data('userid');
        $('#primaryUserID').val(searchUserID);

        quoteAmount = $this.data('quoteamount');
        $('#quoteAmount').val(quoteAmount);

        let projectID = $this.data('projectid');
        $('#dialogQuoteID', $dialog).html(projectID);

        let openhash = $this.data('openhash');

        if (typeof dialogOrderNo !== 'undefined') {
            let dialogOrderNo = $this.data('dialogorderno');
        }
        $('#dialogOrderNo', $dialog).val();

        $dialog.data('projectid', $this.data('projectid'));
        $dialog.data('dialogorderno', $this.data('dialogorderno'));
        $dialog.data('openhash', $this.data('openhash'));
        $dialog.data('projecttype', $this.data('projecttype'));
        $dialog.data('userid', $this.data('userid'));
        $dialog.data('quoteamount', $this.data('quoteamount'));

        if (additionalCustomers) {
            const $customerListSelect = $('#customerListSelect', $dialog);
            $customerListSelect.empty();

            $.ajax({
                type: "POST",
                url: "../common/ajax/editProject.php",
                data: "getAdditionalCustomers=" + projectID + "&openHash=" + openhash,
                dataType: "json",
                async: false,
                success: function (responseText) {
                    $.each(responseText, function (i, item) {
                        let $option = new Option(item.name, item.userID);
                        $($option).attr('data-ordernoreq', item.orderNoReq);
                        $customerListSelect.append($option);
                    });
                    $customerListSelect.suggestselect('setValue', -1);
                },
                error: function (data) {
                    let txtMessage = gettext('Retrieval of Additional Customers failed');
                    createDialog("alert", txtMessage, gettext("Additional Customers"));
                    hideLoadingImage();
                }
            });
        }
    } else if ($this.attr('id') === 'customerListSelect') {
        // from dialog, changed additional customer selection
        let $customerListSelect = $this;
        additionalCustomers = true;
        checkCustomerCredit = true;
        orderNoNeeded = $customerListSelect.find(':selected').data('ordernoreq');
        let selectedUserID = $customerListSelect.val();
        if (selectedUserID === '-1') {
            searchUserID = $('#primaryUserID').val();
        } else {
            searchUserID = selectedUserID;
        }
        quoteAmount = $('#quoteAmount').val();
    } else {
        unknownQuoteCovertFail();
    }

    if (checkCustomerCredit) {
        if (typeof quoteAmount === 'undefined') {
            unknownQuoteCovertFail();
        }

        $.ajax({
            type: 'POST',
            url: '../common/ajax/editProject.php',
            data: 'checkCustomerCredit=' + searchUserID + '&qa=' + quoteAmount,
            dataType: 'json',
            async: false,
            success: function (responseText) {
                if (responseText.success) {
                    if (typeof responseText.messageName !== 'undefined') {
                        preventConvert = true;
                        $('#convertQuoteOkBtn', $dialog).prop('disabled', true).hide();
                        $('#creditLimitExceededContinue', $dialog).hide();
                        $('#creditLimitExceeded', $dialog).show();
                        $('#dialogCreditLimitCustomerName', $dialog).html(responseText.messageName);
                        $('.creditLimitMessages', $dialog).show();
                    } else if (typeof responseText.messageAmount !== 'undefined') {
                        preventConvert = true;
                        $('#convertQuoteOkBtn', $dialog).prop('disabled', false).show();
                        $('#creditLimitExceeded', $dialog).hide();
                        $('#creditLimitExceededContinue', $dialog).show();
                        $('#dialogCreditLimitAmount', $dialog).html(responseText.messageAmount);
                        $('.creditLimitMessages', $dialog).show();
                    } else {
                        preventConvert = false;
                        $('#convertQuoteOkBtn', $dialog).prop('disabled', false).show();
                        $('.creditLimitMessages', $dialog).hide();
                        $('#creditLimitExceeded', $dialog).hide();
                        $('#creditLimitExceededContinue', $dialog).hide();
                        $('#dialogCreditLimitAmount', $dialog).html('');
                        $('#dialogCreditLimitCustomerName', $dialog).html('');
                    }
                } else {
                    unknownQuoteCovertFail();
                }
            },
            error: function (data) {
                unknownQuoteConvertFail();
            }
        });
    } else {
        preventConvert = false;
        $('#convertQuoteOkBtn', $dialog).prop('disabled', false).show();
        $('.creditLimitMessages', $dialog).hide();
        $('#creditLimitExceeded', $dialog).hide();
        $('#creditLimitExceededContinue', $dialog).hide();
        $('#dialogCreditLimitAmount', $dialog).html('');
        $('#dialogCreditLimitCustomerName', $dialog).html('');
    }

    if (!preventConvert && optCostCentreMsgNeeded) {
        $('.optCostCentreMsgNeeded', $dialog).show();
    } else {
        $('.optCostCentreMsgNeeded', $dialog).hide();
    }

    // ignores preventConvert state because different customers may be able to convert
    if (additionalCustomers) {
        $('.additionalCustomers', $dialog).show();
    } else {
        $('.additionalCustomers', $dialog).hide();
    }

    if (!preventConvert && orderNoNeeded) {
        $('#dialogOrderNo', $dialog).addClass('mandatory');
        $('.orderNoNeeded', $dialog).show();
    } else {
        $('#dialogOrderNo', $dialog).removeClass('mandatory');
        $('.orderNoNeeded', $dialog).hide();
    }
    hideLoadingImage();
    prepareDocument($dialog);
    $dialog
        .show()
        .undelegate('.dialogClose', 'click')
        .delegate('.dialogClose', 'click', function() {
            // if Cancel, change option back to "Choose One".
            $('#convertTo').suggestselect('setValue', -1);
        })
        .delegate('#customerListSelect', 'change', renderQuoteConvertDialog);
    return false;
}

function unknownQuoteConvertFail() {
    $('#convertQuoteDialog').hide();
    hideLoadingImage();
    createDialog(
        'alert',
        gettext('An error occurred while trying to convert the quote. Please try again later and if the problem persists, please contact support.'),
        gettext('Error')
    );
    return false;
}
